import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { withMedia } from 'react-media-query-hoc';
import getArea from '@domain-group/fe-allhomes-library/lib/utils/get-area';
import * as styles from './desktop-blockmap.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var BlockMap = _ref => {
  var imageUrl = _ref.imageUrl,
    imageAlt = _ref.imageAlt,
    linkUrl = _ref.linkUrl,
    disclaimerText = _ref.disclaimerText,
    block = _ref.block,
    section = _ref.section,
    suburb = _ref.suburb,
    unimprovedValue = _ref.unimprovedValue,
    blockSize = _ref.blockSize,
    blockSizeApprox = _ref.blockSizeApprox,
    legalDescription = _ref.legalDescription,
    media = _ref.media;
  var renderImage = () => {
    var imageNode = ___EmotionJSX("img", {
      css: styles.image(!imageUrl),
      src: imageUrl || "https://s.domainstatic.com.au/content/fe-static/@domain-group/fe-co-allhomes-listing-map/static/empty-block_b1e194ab.svg",
      alt: imageAlt
    });
    if (linkUrl) {
      return ___EmotionJSX("a", {
        css: styles.link,
        href: linkUrl
      }, imageNode);
    }
    return media.mobile && isEmpty(imageUrl) ? ___EmotionJSX("br", null) : imageNode;
  };
  var blockSizeArea = blockSize ? getArea(blockSize) : null;
  var isNotBlank = !media.mobile || !!(block || section || blockSize || unimprovedValue || legalDescription);
  return ___EmotionJSX("div", {
    css: styles.container
  }, isNotBlank && ___EmotionJSX("div", {
    css: styles.title
  }, "Block information"), block && section && ___EmotionJSX("div", {
    css: styles.infoItem
  }, "Block ", block, " Section ", section, " ", suburb), blockSizeArea && ___EmotionJSX("div", {
    css: styles.infoItem
  }, "Block size: ", blockSizeArea.value, blockSizeArea.unit, " ", blockSizeApprox ? ' (approx)' : ''), unimprovedValue && ___EmotionJSX("div", {
    css: styles.infoItem
  }, "Unimproved value: ", unimprovedValue), legalDescription && ___EmotionJSX("div", {
    css: styles.infoItem
  }, "Legal description: ", legalDescription), ___EmotionJSX("div", {
    css: styles.imageContainer
  }, renderImage(), !imageUrl && !media.mobile && ___EmotionJSX("div", {
    css: styles.noImageText
  }, "No block information available")), isNotBlank && ___EmotionJSX("div", {
    css: styles.disclaimerText,
    dangerouslySetInnerHTML: {
      __html: disclaimerText
    } // eslint-disable-line react/no-danger
  }));
};
BlockMap.propTypes = {
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  linkUrl: PropTypes.string,
  disclaimerText: PropTypes.string.isRequired,
  block: PropTypes.string,
  section: PropTypes.string,
  suburb: PropTypes.string,
  unimprovedValue: PropTypes.string,
  blockSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  blockSizeApprox: PropTypes.bool,
  legalDescription: PropTypes.string,
  media: PropTypes.shape({
    mobile: PropTypes.bool
  })
};
BlockMap.defaultProps = {
  imageUrl: null,
  linkUrl: null,
  imageAlt: 'Block Map',
  blockSizeApprox: false,
  block: null,
  section: null,
  suburb: '',
  unimprovedValue: null,
  blockSize: null,
  legalDescription: null,
  media: {}
};
export default withMedia(BlockMap);